import { getAppInsights } from '../../appInsights';
(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("authService", ["$rootScope", "$http", "$q", "$localStorage", "_", "USER_ROLES", "$state", "$translate", "userHubService", "learningPlanService", authService]);
    function authService($rootScope, $http, $q, $localStorage, _, USER_ROLES, $state, $translate, userHubService, learningPlanService) {
        var authServiceFactory = {};
        var authentication = {};
        initAuthentication();
        function initAuthentication() {
            authentication.clientId = "";
            authentication.emailConfirmed = false;
            authentication.endSessionEndpoint = "";
            authentication.forumDisplayName = "";
            authentication.hasInventory = false;
            authentication.hasSkillCheck = false;
            authentication.isAdmin = false;
            authentication.isAuth = false;
            authentication.isLearner = true;
            authentication.isMissingRegistrationData = false;
            authentication.originalUsername = "";
            authentication.pictureUrl = "";
            authentication.roles = [];
            authentication.tenantCode = "";
            authentication.tenantId = 0;
            authentication.token = "";
            authentication.userId = "";
            authentication.userEmail = "";
            authentication.userFirstName = "";
            authentication.userFullName = "";
            authentication.userImpersonation = false;
            authentication.userLastName = "";
            authentication.userName = "";
            authentication.userPersonSeq = "";
            authentication.organizationName = "";
            authentication.organizationId = null;
        }
        var setAuthenticationData = function (response, callAngularFillAuthData) {
            if (callAngularFillAuthData === void 0) { callAngularFillAuthData = false; }
            authentication.clientId = response.clientId;
            authentication.emailConfirmed = response.emailConfirmed;
            authentication.endSessionEndpoint = response.endSessionEndpoint;
            authentication.forumDisplayName = response.forumDisplayName;
            authentication.hasInventory = response.hasInventory;
            authentication.hasSkillCheck = response.hasSkillCheck;
            authentication.isAdmin = response.isAdmin;
            authentication.isAuth = true; //authentication.emailConfirmed; //Yes, you can be Auth and not email confirmed (checkout) //should not be authorized if the email is not confirmed
            authentication.isLearner = true;
            authentication.originalUsername = response.originalUsername;
            authentication.pictureUrl = response.pictureUrl;
            authentication.roles = response.roles.split(",");
            authentication.tenantCode = response.tenantCode;
            authentication.tenantId = response.tenantId;
            authentication.token = response.token;
            authentication.userId = response.userId;
            authentication.userEmail = response.userEmail;
            authentication.userFirstName = response.userFirstName;
            authentication.userFullName = response.userFirstName + " " + response.userLastName;
            authentication.userImpersonation = response.userImpersonation;
            authentication.userLastName = response.userLastName;
            authentication.userName = response.userName;
            authentication.userPersonSeq = response.userPersonSeq;
            authentication.organizationName = response.organizationName;
            authentication.organizationId = response.organizationId;
            $localStorage.currentLocalizationId = parseInt(response.localizationId);
            $localStorage.selectedLanguage = { culture: response.localizationCulture, name: response.localizationName, id: parseInt(response.localizationId) };
            var authString = JSON.stringify(authentication);
            //$localStorage.authorizationData = Base64.encode(authString);
            $localStorage.authorizationData2 = window.btoa(encodeURIComponent(authString));
            $localStorage.token = response.token;
            //$localStorage.refreshToken = response.refreshToken; // now an httpOnly cookie
            $localStorage.tokenExpiryDate = response.tokenExpires;
            setAuthenticatedUser(response.userName);
            userHubService.start(authentication, function () {
                if (callAngularFillAuthData)
                    $rootScope.$broadcast("angularFillAuthData", authentication); //fill auth data for Angular
                else
                    $rootScope.$broadcast("signInComplete", true); //this also fills auth data for angular, but also redirect to home page
            });
        };
        function setAuthenticatedUser(userId) {
            var appInsights = getAppInsights();
            if (appInsights) {
                appInsights.context.user.setAuthenticatedUserContext(userId);
            }
            else {
                console.error("appInsights is undefined");
            }
        }
        var login = function (loginData) {
            var data = {
                username: loginData.userName,
                password: loginData.password
            };
            var deferred = $q.defer();
            $http.post("/api/auth/login", data)
                .then(function (response) {
                if (response.data.emailConfirmed || loginData.checkout) {
                    setAuthenticationData(response.data, loginData.checkout); //when checking out, do not redirect to homepage
                    var currentCulture = $translate.proposedLanguage() || $translate.use();
                    if (currentCulture !== $localStorage.selectedLanguage.culture)
                        $translate.use($localStorage.selectedLanguage.culture).then(function () { $translate.refresh(); }); //Fix: https://github.com/angular-translate/angular-translate/issues/1781
                    if (loginData.rememberMe)
                        $localStorage.rememberMeData = { userName: loginData.userName, tenantId: loginData.tenantId, tenantCode: loginData.tenantCode };
                    else
                        delete $localStorage.rememberMeData;
                }
                deferred.resolve(response.data);
            }, function (error) {
                logOut();
                deferred.reject(error.data);
            });
            return deferred.promise;
        };
        var impersonate = function (username) {
            if (userHubService.isConnected) {
                userHubService.stop();
            }
            var deferred = $q.defer();
            $http.post("api/auth/impersonate/" + username)
                .then(function (response) {
                setAuthenticationData(response.data, true);
                var currentCulture = $translate.proposedLanguage() || $translate.use();
                if (currentCulture !== $localStorage.selectedLanguage.culture)
                    $translate.use($localStorage.selectedLanguage.culture).then(function () { $translate.refresh(); }); //Fix: https://github.com/angular-translate/angular-translate/issues/1781
                deferred.resolve(response.data);
            }, function (error) {
                logOut();
                deferred.reject(error);
            });
            return deferred.promise;
        };
        var endImpersonate = function () {
            if (userHubService.isConnected) {
                userHubService.stop();
            }
            var deferred = $q.defer();
            $http.post("api/auth/endImpersonate")
                .then(function (response) {
                setAuthenticationData(response.data, true);
                var currentCulture = $translate.proposedLanguage() || $translate.use();
                if (currentCulture !== $localStorage.selectedLanguage.culture)
                    $translate.use($localStorage.selectedLanguage.culture).then(function () { $translate.refresh(); }); //Fix: https://github.com/angular-translate/angular-translate/issues/1781
                deferred.resolve(response.data);
            }, function (error) {
                logOut();
                deferred.reject(error);
            });
            return deferred.promise;
        };
        var logOut = function () {
            var deferred = $q.defer();
            $rootScope.$broadcast("clearSubscriptionNotify");
            if (userHubService.isConnected) {
                userHubService.stop();
            }
            if (authentication.isAuth) {
                var endSessionEndpoint = authentication.endSessionEndpoint;
                learningPlanService.data = {};
                $http.post("api/Accounts/Logout")
                    .then(function () {
                    initAuthentication();
                    delete $localStorage.authorizationData2;
                    delete $localStorage.token;
                    //delete $localStorage.refreshToken;
                    delete $localStorage.tokenExpiryDate;
                    delete $localStorage.storefrontCart3;
                    $rootScope.$broadcast("updateShoppingCartCount", 0);
                    $rootScope.$broadcast("userSignedOut");
                    if (endSessionEndpoint) {
                        console.log("endSessionEndpoint: ", endSessionEndpoint);
                        window.location.href = endSessionEndpoint;
                    }
                    else {
                        deferred.resolve(null);
                    }
                }, function () {
                    //do nothing
                });
            }
            else {
                initAuthentication();
                delete $localStorage.authorizationData2;
                delete $localStorage.token;
                //delete $localStorage.refreshToken;
                delete $localStorage.tokenExpiryDate;
                delete $localStorage.storefrontCart3;
                $rootScope.$broadcast("updateShoppingCartCount", 0);
                deferred.resolve(null);
            }
            return deferred.promise;
        };
        var getToken = function () {
            if (authentication.isAuth)
                return authentication.token;
            //if ($localStorage.token && $localStorage.token !== "")
            //	return $localStorage.token;
            $state.go("main.signIn");
            return "";
        };
        var getTokenExpiryDate = function () {
            if ($localStorage.tokenExpiryDate && $localStorage.tokenExpiryDate !== "")
                return $localStorage.tokenExpiryDate;
            return "";
        };
        var fillAuthData = function () {
            //Checking if the token is expired before authorize the user.
            if ($localStorage.authorizationData2 && $localStorage.tokenExpiryDate && new Date($localStorage.tokenExpiryDate) > new Date()) {
                try {
                    var decoded = decodeURIComponent(window.atob($localStorage.authorizationData2));
                    var authData = JSON.parse(decoded);
                    angular.extend(authentication, authData);
                    userHubService.start(authentication);
                }
                catch (e) {
                    //Silent exception
                    console.error(e);
                }
            }
        };
        var refreshAuthData = function () {
            if ($localStorage.authorizationData2) {
                try {
                    //var decoded = Base64.decode($localStorage.authorizationData);
                    var decoded = decodeURIComponent(window.atob($localStorage.authorizationData2));
                    var authData = JSON.parse(decoded);
                    if (authentication.userPersonSeq !== authData.userPersonSeq) {
                        angular.extend(authentication, authData);
                        userHubService.start(authentication, function () {
                            $rootScope.$broadcast("angularFillAuthData", authentication); //Fill user data for Angular
                            $rootScope.$broadcast("hideAdminMenu:updated");
                        });
                        return true;
                    }
                }
                catch (e) {
                    //Silent exception
                    console.error(e);
                }
            }
            return false;
        };
        var isAuthorized = function (authorizedRoles) {
            if (!authentication.isAuth)
                return false;
            if (!angular.isArray(authorizedRoles)) {
                authorizedRoles = [authorizedRoles];
            }
            if (authorizedRoles.indexOf(USER_ROLES.all) > -1 && authentication.roles.length > 0) {
                return true;
            }
            return _.intersection(authorizedRoles, authentication.roles).length > 0;
        };
        var updateUserData = function (userData) {
            //TODO - PBI - update user profile as well
            if (userData.firstName)
                authentication.userFirstName = userData.firstName;
            if (userData.lastName)
                authentication.userLastName = userData.lastName;
            if (userData.firstName || userData.lastName)
                authentication.userFullName = authentication.userFirstName + " " + authentication.userLastName;
            if (userData.pictureUrl !== undefined)
                authentication.pictureUrl = userData.pictureUrl;
            var authString = JSON.stringify(authentication);
            $localStorage.authorizationData2 = window.btoa(encodeURIComponent(authString));
        };
        var currentUserPersonSeq = function () {
            return authentication.userPersonSeq;
        };
        var isSuperAdmin = function () {
            return _.includes(authentication.roles, "Super Admin");
        };
        var isSiteAdmin = function () {
            return _.includes(authentication.roles, "Site Admin");
        };
        var isSuperOrSiteAdmin = function () {
            return _.includes(authentication.roles, "Super Admin") || _.includes(authentication.roles, "Site Admin");
        };
        var isGroupOrOrgAdmin = function () {
            if (isSuperAdmin())
                return false;
            if (isSiteAdmin())
                return false;
            return _.includes(authentication.roles, "Group Admin") || _.includes(authentication.roles, "Organization Admin");
        };
        var isOrgAdmin = function () {
            if (isSuperAdmin())
                return false;
            if (isSiteAdmin())
                return false;
            return _.includes(authentication.roles, "Organization Admin");
        };
        var isGroupAdmin = function () {
            if (isSuperAdmin())
                return false;
            if (isSiteAdmin())
                return false;
            return _.includes(authentication.roles, "Group Admin");
        };
        var refreshToken = function () {
            var url = "/api/auth/refresh";
            var deferred = $q.defer();
            $http.post(url)
                .then(function (response) {
                userHubService.stop(function () {
                    setAuthenticationData(response.data, true);
                    deferred.resolve(null);
                });
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        };
        // ReSharper disable AssignedValueIsNeverUsed
        // code copied from the webs
        //var Base64 = {
        //	keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        //	encode: function (input) {
        //		var output = "";
        //		var chr1, chr2, chr3: any = "";
        //		var enc1, enc2, enc3, enc4: any = "";
        //		var i = 0;
        //		do {
        //			chr1 = input.charCodeAt(i++);
        //			chr2 = input.charCodeAt(i++);
        //			chr3 = input.charCodeAt(i++);
        //			enc1 = chr1 >> 2;
        //			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        //			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        //			enc4 = chr3 & 63;
        //			if (isNaN(chr2)) {
        //				enc3 = enc4 = 64;
        //			} else if (isNaN(chr3)) {
        //				enc4 = 64;
        //			}
        //			output = output +
        //				this.keyStr.charAt(enc1) +
        //				this.keyStr.charAt(enc2) +
        //				this.keyStr.charAt(enc3) +
        //				this.keyStr.charAt(enc4);
        //			chr1 = chr2 = chr3 = "";
        //			enc1 = enc2 = enc3 = enc4 = "";
        //		} while (i < input.length);
        //		return output;
        //	},
        //	decode: function (input) {
        //		var output = "";
        //		var chr1, chr2, chr3: any = "";
        //		var enc1, enc2, enc3, enc4: any = "";
        //		var i = 0;
        //		// remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        //		var base64test = /[^A-Za-z0-9\+\/\=]/g;
        //		if (base64test.exec(input)) {
        //			window.alert("There were invalid base64 characters in the input text.\n" +
        //				"Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
        //				"Expect errors in decoding.");
        //		}
        //		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        //		do {
        //			enc1 = this.keyStr.indexOf(input.charAt(i++));
        //			enc2 = this.keyStr.indexOf(input.charAt(i++));
        //			enc3 = this.keyStr.indexOf(input.charAt(i++));
        //			enc4 = this.keyStr.indexOf(input.charAt(i++));
        //			chr1 = (enc1 << 2) | (enc2 >> 4);
        //			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        //			chr3 = ((enc3 & 3) << 6) | enc4;
        //			output = output + String.fromCharCode(chr1);
        //			if (enc3 !== 64) {
        //				output = output + String.fromCharCode(chr2);
        //			}
        //			if (enc4 !== 64) {
        //				output = output + String.fromCharCode(chr3);
        //			}
        //			chr1 = chr2 = chr3 = "";
        //			enc1 = enc2 = enc3 = enc4 = "";
        //		} while (i < input.length);
        //		return output;
        //	}
        //};
        //called from the sign-in ctrl to save the isMissingRegistrationData flag to local storage with the rest of user data
        var saveAuthenticationDataToLocalStorage = function () {
            var authString = JSON.stringify(authentication);
            $localStorage.authorizationData2 = window.btoa(encodeURIComponent(authString));
        };
        //authServiceFactory.saveRegistration = _saveRegistration;
        authServiceFactory.endImpersonate = endImpersonate;
        authServiceFactory.impersonate = impersonate;
        authServiceFactory.login = login;
        authServiceFactory.logOut = logOut;
        authServiceFactory.getToken = getToken;
        authServiceFactory.fillAuthData = fillAuthData;
        authServiceFactory.refreshAuthData = refreshAuthData;
        authServiceFactory.authentication = authentication;
        authServiceFactory.isAuthorized = isAuthorized;
        authServiceFactory.updateUserData = updateUserData;
        authServiceFactory.currentUserPersonSeq = currentUserPersonSeq;
        authServiceFactory.isSuperAdmin = isSuperAdmin;
        authServiceFactory.isSiteAdmin = isSiteAdmin;
        authServiceFactory.isSuperOrSiteAdmin = isSuperOrSiteAdmin;
        authServiceFactory.isGroupOrOrgAdmin = isGroupOrOrgAdmin;
        authServiceFactory.isGroupAdmin = isGroupAdmin;
        authServiceFactory.isOrgAdmin = isOrgAdmin;
        authServiceFactory.refreshToken = refreshToken;
        authServiceFactory.getTokenExpiryDate = getTokenExpiryDate;
        authServiceFactory.saveAuthenticationDataToLocalStorage = saveAuthenticationDataToLocalStorage;
        authServiceFactory.setAuthenticationData = setAuthenticationData;
        return authServiceFactory;
    }
}());
